/* eslint-disable react-refresh/only-export-components */
// packages/web/src/pages/Super/components/shared/PhoneFaxFieldsGroup.tsx
import type { ReactNode } from 'react'
import { Group, InputBase } from '@mantine/core'
import { IMaskInput } from 'react-imask'

export const tenDigitValidation = (value: string): string | null => {
  if (!value) return null
  const digits = value.replace(/\D/g, '')
  return digits.length === 10 ? null : 'Invalid number'
}

interface PhoneFaxFieldsGroupProps {
  phoneValue: string
  faxValue: string
  phoneError?: ReactNode
  faxError?: ReactNode
  onPhoneChange: (value: string) => void
  onFaxChange: (value: string) => void
}

export function PhoneFaxFieldsGroup({
  phoneValue,
  faxValue,
  phoneError,
  faxError,
  onPhoneChange,
  onFaxChange,
}: PhoneFaxFieldsGroupProps) {
  return (
    <Group grow>
      <InputBase
        label="Phone"
        placeholder="(000) 000-0000"
        component={IMaskInput}
        mask="(000) 000-0000"
        value={phoneValue}
        onAccept={(value) => onPhoneChange(value)}
        error={phoneError}
      />
      <InputBase
        label="Fax"
        placeholder="(000) 000-0000"
        component={IMaskInput}
        mask="(000) 000-0000"
        value={faxValue}
        onAccept={(value) => onFaxChange(value)}
        error={faxError}
      />
    </Group>
  )
}
